import React from "react";

interface Props {
  size?: number;
  color?: string;
}
export default function PipetteIcon({
  size = 20,
  color = "#79808A",
}: Props) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.2583 4.88733C14.307 4.088 14.0223 3.29533 13.4943 2.768C13.0063 2.28067 12.299 2 11.553 2C10.769 2 10.0823 2.302 9.66962 2.82867C9.20829 3.41733 8.74162 4.57867 8.49029 5.26L7.41296 4.182C7.28794 4.05702 7.1184 3.98681 6.94162 3.98681C6.76485 3.98681 6.59531 4.05702 6.47029 4.182C6.40817 4.24377 6.35887 4.31721 6.32523 4.3981C6.29159 4.47899 6.27427 4.56573 6.27427 4.65333C6.27427 4.74094 6.29159 4.82768 6.32523 4.90857C6.35887 4.98946 6.40817 5.0629 6.47029 5.12467L6.66562 5.32L3.17829 8.808C2.92829 9.058 2.69896 9.416 2.53296 9.81867C2.52029 9.84733 1.38229 12.704 2.47096 13.7913C2.82229 14.142 3.35762 14.2627 3.92296 14.2627C5.10829 14.2613 6.42496 13.738 6.44496 13.7287C6.84629 13.5633 7.20562 13.334 7.45429 13.084L10.9423 9.596L11.1376 9.79133C11.1994 9.85346 11.2728 9.90276 11.3537 9.9364C11.4346 9.97004 11.5214 9.98736 11.609 9.98736C11.6966 9.98736 11.7833 9.97004 11.8642 9.9364C11.9451 9.90276 12.0185 9.85346 12.0803 9.79133C12.2053 9.66632 12.2755 9.49678 12.2755 9.32C12.2755 9.14322 12.2053 8.97369 12.0803 8.84867L11.0023 7.77133C11.6843 7.52067 12.8463 7.05467 13.4343 6.592C13.915 6.21733 14.2143 5.59667 14.2583 4.88733ZM3.41496 12.85C3.25029 12.6533 3.34496 11.8447 3.51762 11.13L5.13229 12.7453C4.41829 12.9193 3.61029 13.014 3.41496 12.85ZM6.51162 12.1427C6.38629 12.268 6.17096 12.4013 5.93496 12.498L5.85762 12.526L3.73696 10.406L3.76562 10.328C3.86296 10.092 3.99629 9.876 4.12096 9.752L7.60896 6.26467L9.99962 8.65533L6.51162 12.1427Z"
        fill={color}
      />
    </svg>
  );
}
